const mobile={
    boxSizing:"border-box",
    borderRadius:"2px",
    boxShadow: "0 2px 2px 0 rgba(0,0,0,0.1)",
    display:"inline-block",
    margin:"0 0 32px",
    position:"absolute",
      top:"24px",
      left:"24px",
}
const desktop={
    boxSizing:"border-box",
    borderRadius:"2px",
    boxShadow: "0 2px 2px 0 rgba(0,0,0,0.1)",
    position:"absolute",
    top:"24px",
    left:"24px",
   
}

const styles = {
  divStyle:window.innerWidth>899?desktop:mobile,
}

export default styles;
